import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutePath } from 'app/routing/routes';
import { ConfigService } from 'app/_services/config.service';

@Component({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent implements OnInit {
    constructor(private config: ConfigService, private router: Router) {}

    ngOnInit() {
        const self = this;
        if (self.config.systemActiveValue) {
            self.router.navigate([RoutePath.Home]);
        }
    }
}
